/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { Alert, Card, Text } from '@mantine/core'
import AnchorLink from '../AnchorLink'
import Page from '../Page'

function NotFoundPage () {
  return (
    <Page>
      <Card>
        <Alert
          icon={<FontAwesomeIcon icon={faExclamationCircle} />}
          title={<FormattedMessage
            id="page_not_found"
            defaultMessage="Page introuvable"
          />}
        >
          <Text>
            <FormattedMessage
              id="page_not_found_message"
              defaultMessage="La page à laquelle vous tentez d'accéder n'existe pas."
            />
          </Text>
          <AnchorLink mt="md" to="/">
            <FormattedMessage
              id="return_to_home"
              defaultMessage="Retourner sur la page d'accueil"
            />
          </AnchorLink>
        </Alert>
      </Card>
    </Page>
  )
}

export default NotFoundPage
